import React from "react";

import { ProfileIcon } from "../ProfileIcon";

import "./ProfileMenu.scss";

export type ProfileMenuProps = {
  cx?: string;
  username: string;
  email: string;
  list: { icon: unknown; text: string; click: any }[];
};

export const ProfileMenu: React.FC<ProfileMenuProps> = ({
  cx = "",
  username,
  email,
  list,
}) => {
  return (
    <div className={`ProfileMenu ${cx}`}>
      <div className={"profile-text"}>
        <ProfileIcon username={username} />
        <div className={"user-info"}>
          <span>{username}</span>
          <span>{email}</span>
        </div>
      </div>
      <ul>
        {list.map(({ icon, text, click }) => (
          <li key={`${text}-profile`} onClick={click}>
            <>{icon}</>
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
};
